
import { defineComponent, ref, watch } from 'vue';
import { useStore } from 'vuex';
export default defineComponent({
  name: 'HeadBar',
  setup() {
    // 导航栏内容
    const tags = [
      {
        icon: 'el-home',
        index: '/main',
        title: '首页',
      },
      {
        icon: 'el-home',
        index: '/service',
        title: '自助服务',
      },
      {
        icon: 'el-home',
        index: '/guide',
        title: '帮助',
      },
      {
        icon: 'el-home',
        index: '/info',
        title: '个人信息',
      },
    ];
    // 响应式切换导航栏
    const store = useStore();
    const selectItem = (index: string) => {
      store.commit('changeActiveHead', index);
    };
    const activeItem = ref('');
    activeItem.value = store.state.activeHeadItem;
    watch(
      () => store.state.activeHeadItem,
      () => (activeItem.value = store.state.activeHeadItem)
    );
    return {
      tags,
      selectItem,
      activeItem,
    };
  },
});
